// extracted by mini-css-extract-plugin
module.exports = {"asterisk":"Post-register_asterisk__1VEHw","button":"Post-register_button__1SD_V","buttonContent":"Post-register_buttonContent__1wx2p"};